import { Icon } from 'app/components/common/Icon';

export const RingDisclaimer = () => {
	return (
		<div className="pad-1rem color-grey border-bottom">
			<Icon iconClass="info-circle" faModifier="fal" /> Bitte beachten Sie, dass eventuelle EH für die Erreichung der Ringausschreibung nicht abgebildet sind.
		</div>
	);
};
